import { useEffect } from 'react';
import useFaceModel from 'Store/face-model';

const FaceModelLoader = () => {
  const loadFaceModel = useFaceModel((state) => state.loadFaceModel);

  useEffect(() => {
    loadFaceModel();
  }, [loadFaceModel]);

  return null;
};

export default FaceModelLoader;
